export function usersInfoBuilderUI(info) {
  return {
    ...info,
    fullName: `${info.firstName} ${info.lastName}`,
    hasUserImage: false
  };
}
